// Home-new (test) hero video PLAYBACK — intro plays once, then loops from
// LOOP_START. Visual choreography (fullscreen → contained, navbar + header
// reveal) lives in ./cinematic-hero.js; this file only owns play/pause/loop.
//
// LOOP_START = where the video loops back to after it plays through to the end.
// This is the EXACT intro→loop boundary Elay measured: timecode 0:00:05:16 =
// frame 316 @60fps = 5.26667s. In the combined clip the seamless "Loop" segment
// is frames 316–720 (405 frames = the full authored loop), so looping from here
// is seam-perfect. The clip is 60fps (so frame 316 exists exactly) with a forced
// keyframe at 316 (instant seek). Video plays 0→end, then loops [LOOP_START→end].
export const LOOP_START = 5.2667;

export function initVideoHero() {
  const video = document.getElementById('hp-hero_video');
  if (!video) return;

  const safePlay = () => {
    const p = video.play();
    if (p && typeof p.catch === 'function') p.catch(() => {});
  };

  // Intro → loop handoff.
  video.addEventListener('ended', () => {
    video.currentTime = LOOP_START;
    safePlay();
  });

  // Pause offscreen, resume when back in view.
  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        if (video.ended || video.paused) {
          if (video.ended) video.currentTime = LOOP_START;
          safePlay();
        }
      } else {
        video.pause();
      }
    },
    { threshold: 0.1 }
  );

  observer.observe(video);
}
